import Error from './component/Error';

function InternalServerErrorView() {
  return (
    <Error
      status={500}
      title="Internal Server Error"
      description="Something went wrong, please try again later.."
    />
  );
}

export default InternalServerErrorView;
